function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#1CA6FF",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  strokeWidth: 2.053
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7AC52E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.142,
  d: "M28.323 27.787l7.416-3.548-7.496-3.207 7.491-3.584-11.832-5.128-12.096 5.128 7.833 3.666-7.854 3.236 7.696 3.525-7.721 3.167 12.142 5.278 11.858-5.27-7.437-3.263zM13.776 17.485l10.123-4.292 9.901 4.291-9.901 4.738-10.123-4.737zm.02 6.904l6.83-2.813 3.277 1.533 3.378-1.616 6.514 2.787-9.898 4.736-10.1-4.627zM23.9 35.444l-10.077-4.38 6.658-2.731 3.425 1.569 3.463-1.657 6.406 2.81-9.875 4.389z"
}));

const SvgIcSaasBackup = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSaasBackup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-saas-backup.53200bc6.svg";
export { ForwardRef as ReactComponent };